import Venues from 'Pages/Site/Venues';
import Faq from "Pages/Site/faqs";

export default [
    { path: '/venues', component: Venues, guards: ['auth'] },
    { path: '/faqs', component: Faq, guards: ['auth'] },
];
